class CnRGWP {
    constructor(options) {

        this.options = options;
        this.processing = false;
        this.customerTags = this.options.customerTags;

		let tier_amounts = options["amounts"].split(",");
		let tier_items = options["items"].split(",");

		this.tiers = tier_amounts.map((element,index)=>{
          return {
			'min':parseInt(element),
			'max':(tier_amounts[index+1])?parseInt(tier_amounts[index+1])-1:99999999999,
			'id':parseInt(tier_items[index])
    		}
        });
			
		if (this.options['cart']=="gocart") {
        	document.addEventListener("CartUpdated",(event)=>{
				this.process(window.cart);
			});
		}
    }
    process(cart) {

        if (this.processing) {
          console.error("DOUBLETAP");
          return;
        }
          this.processing = true;
        let gift_item = cart.items.find(item=>item.properties && item.properties["_cr_gwp"]==this.options.campaign);
        let gift_index = cart.items.findIndex(item=>item.properties && item.properties["_cr_gwp"]==this.options.campaign);
		
        cart.items.forEach((item,index)=>{

            // fix to prevent from using a free gift by adding it manually
            if (item?.product_tags && item?.product_tags.includes('free-gift') && gift_item !== item) {
                this.removeItemWithId(item.id, () => {
                    this.postAdd();
                });
            }


            if (item.properties && item.properties["_cr_gwp"]==this.options.campaign) {
                gift_item = item;
                gift_index = index+1;
            }
        });
                
        let eligible_gift = this.tiers.find(
            tier=>window.cart.items_subtotal_price>=tier.min && window.cart.items_subtotal_price<=tier.max
        );
        
        if (!eligible_gift) {
            if (gift_item) {
                this.removeItemAt(gift_index,()=>{this.postAdd()});
            }
        } else {

            if (gift_item) {
                if (gift_item.id != eligible_gift.id) {
                    this.removeItemAt(gift_index,()=>{
                        this.addItem(eligible_gift.id,gift_item.properties,()=>{this.postAdd()});
                    });
                }else if (gift_item.quantity>1) {
                  this.fixQuantity(gift_index,()=>this.postAdd());
                }
            } else {

                let properties =  {
                    "_cr_gwp":this.options.campaign,
                  };

              if (!this.customerTags.includes('B2B')) {
                this.addItem(eligible_gift.id,properties,()=>{this.postAdd()});
              }
            }
        }
      this.processing =false;
    }
    postAdd() {
      if (this.options.cart=="gocart") {
        window.setTimeout(()=>{
          console.error("postadd");
          goCart.fetchAndOpenCart();
        },400);
      }
  
    }
    addItem(id,properties,callback) {
        
        window.fetch("/cart/add.js",{
            method:"POST",
            body:JSON.stringify({id:id,quantity:1,properties:properties}),
            headers:{"Content-type":"application/json"}
        }).then(response=>response.json())
        .then(json=>callback())
        .catch(error=>console.error("error",error));
    }
    fixQuantity(index,callback) {
      window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({'quantity':1, 'line':index}),
            headers: {
               'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((json) =>callback())
        .catch((error) => {console.error(error)});
    }
    removeItemAt(index,callback) {
      if (this.removing) { return;}
      this.removing=true;
        let quantity = 0;
        //sanity check!
        if (window.cart.items[index-1].properties && !window.cart.items[index-1].properties['_cr_gwp']) {
          console.error(`tried to remove ${window.cart.items[index].title}!`);
          return;
        }
        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({'quantity':quantity, 'line':index}),
            headers: {
               'Content-Type': 'application/json',
            },
        })
        .then((response) => response.json())
        .then((json) =>{this.removing=false;callback()})
        .catch((error) => {console.error(error)});
    }
    removeItemWithId(id, callback) {
        if (this.removing) {
            return;
        }
        this.removing = true;
        let quantity = 0;

        window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            body: JSON.stringify({'quantity': quantity, 'id': String(id)}),
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                response.json()
            })
            .then((json) => {
                this.removing = false;
                callback()
            })
            .catch((error) => {
                console.error(error)
            });
    }
}
